<template>
  <div>
    <div v-if="shop === 'Gracz'">
      <OrderDetailGracz />
    </div>
    <div v-else-if="shop === 'Rattana'">
      <OrderDetailRattana />
    </div>
    <div v-else-if="shop === 'Sale Order'">
      <OrderDetailSaleOrder />
    </div>
  </div>
</template>
<script>
import { Decode } from '@/services'
export default {
  components: {
    OrderDetailGracz: () => import('@/components/Gracz/Sales/Order/OrderDetailGracz.vue'),
    OrderDetailRattana: () => import('@/components/Gracz/Sales/Order/OrderDetailRattana.vue'),
    OrderDetailSaleOrder: () => import('@/components/Gracz/Sales/Order/OrderDetailSaleOrder.vue')
  },
  data () {
    return {
      userDetailSelling: '',
      shop: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: `/Order/SalesOrderDetailMobile?orderNumber=${this.orderNumber}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/SalesOrderDetail?orderNumber=${this.orderNumber}` }).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    // this.$EventBus.$emit('changeAppBarGracz')
    // this.$EventBus.$emit('changeNav')
    this.$EventBus.$emit('enableCartGracz')
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$EventBus.$emit('changeAppBarPanit')
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      this.orderNumber = this.$route.query.orderNumber
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      this.checkShop()
    }
  },
  methods: {
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    }
  }
}
</script>
